import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxStripeModule } from 'ngx-stripe';
import { SfFormDateComponent } from './components/forms/custom-fields/sf-form-date/sf-form-date.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DROPZONE_CONFIG, DropzoneConfigInterface, DropzoneModule } from 'ngx-dropzone-wrapper';
import { MomentModule } from 'ngx-moment';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserFormComponent } from './components/forms/custom-forms/user-form/user-form.component';
import { SfFormDatetimeComponent } from './components/forms/custom-fields/sf-form-datetime/sf-form-datetime.component';
import { SfFormTimeComponent } from './components/forms/custom-fields/sf-form-time/sf-form-time.component';
import { Ngxh6Module, NotificationBadgeComponent, SfFormFileuploadComponent, SfFormModule } from '@hutsix/ngxh6';
import { NavbarComponent } from './components/ui/navbar/navbar.component';
import { CrmNavbarComponent } from './components/ui/crm-navbar/crm-navbar.component';
import { LoginComponent } from './routes/user/login/login.component';
import { DashboardComponent } from './routes/dashboard/dashboard.component';
import { ReloadPageComponent } from './routes/reload-page/reload-page.component';
import { AccountsNavbarComponent } from './components/ui/accounts-navbar/accounts-navbar.component';
import { CartComponent } from './components/ui/cart/cart.component';
import { CartTableComponent } from './components/tables/cart-table/cart-table.component';
import { OrdersTableComponent } from './components/tables/orders-table/orders-table.component';
import { ItemTableComponent } from './components/tables/item-table/item-table.component';
import { ForgotPasswordComponent } from './routes/user/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './routes/user/forgot-password/reset-password/reset-password.component';
import { SetPasswordComponent } from './routes/user/set-password/set-password.component';
import { InviteComponent } from './routes/user/invite/invite.component';
import { PermitFinderComponent } from './routes/public/permit-finder/permit-finder.component';
import { ApplyStartComponent } from './routes/public/apply-start/apply-start.component';
import { RecreationChooserComponent } from './routes/public/recreation-chooser/recreation-chooser.component';
import { ApplyBusinessLoginComponent } from './routes/public/apply-business-login/apply-business-login.component';
import { PermitTypeChooserComponent } from './components/permit/permit-type-chooser/permit-type-chooser.component';
import { ApplyShellComponent } from './components/permit/apply-shell/apply-shell.component';
import { PermitResultComponent } from './components/permit/permit-result/permit-result.component';
import { ApplyTouristPassComponent } from './routes/public/apply-tourist-pass/apply-tourist-pass.component';
import { ApplyRecreationComponent } from './routes/public/apply-recreation/apply-recreation.component';
import { ApplyFriendsFamilyComponent } from './routes/public/apply-friends-family/apply-friends-family.component';
import { ApplyWorkComponent } from './routes/public/apply-work/apply-work.component';
import { ApplyMediaComponent } from './routes/public/apply-media/apply-media.component';
import { ApplyFishingHuntingComponent } from './routes/public/apply-fishing-hunting/apply-fishing-hunting.component';
import { ApplyResearchComponent } from './routes/public/apply-research/apply-research.component';
import { HostConfirmComponent } from './routes/public/host-confirm/host-confirm.component';
import { ViewPermitComponent } from './routes/public/view-permit/view-permit.component';
import { EditPermitComponent } from './routes/public/edit-permit/edit-permit.component';
import { HomeComponent } from './routes/public/home/home.component';
import { PageComponent } from './routes/public/page/page.component';
import { MyPermitsComponent } from './routes/public/my-permits/my-permits.component';
import { PermitStatusBadgeComponent } from './components/permit/permit-status-badge/permit-status-badge.component';
import { PermitCommonDetailsComponent } from './components/permit/permit-common-details/permit-common-details.component';
import { TouristPassDetailComponent } from './components/permit/tourist-pass-detail/tourist-pass-detail.component';
import { RecreationDetailComponent } from './components/permit/recreation-detail/recreation-detail.component';
import { FriendsFamilyDetailComponent } from './components/permit/friends-family-detail/friends-family-detail.component';
import { WorkDetailComponent } from './components/permit/work-detail/work-detail.component';
import { MediaDetailComponent } from './components/permit/media-detail/media-detail.component';
import { FishingHuntingDetailComponent } from './components/permit/fishing-hunting-detail/fishing-hunting-detail.component';
import { ClosureNoticeComponent } from './components/permit/closure-notice/closure-notice.component';
import { ClosuresTableComponent } from './components/tables/closures-table/closures-table.component';
import { PagesTableComponent } from './components/tables/pages-table/pages-table.component';
import { PermitPayComponent } from './components/permit/permit-pay/permit-pay.component';
import { ResearchDetailComponent } from './components/permit/research-detail/research-detail.component';
import { PermitDetailComponent } from './components/permit/permit-detail/permit-detail.component';
import { PermitHistoryComponent } from './components/permit/permit-history/permit-history.component';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    url: '#',
    maxFilesize: 50,
    // acceptedFiles: '',
    maxFiles: 1,
    addRemoveLinks: true,
    autoQueue: false,
    autoProcessQueue: false,
    uploadMultiple: false,
    headers: {
        'Cache-Control': '',
        'X-Requested-With': '',
    },
    method: 'post',
};

@NgModule({
    declarations: [
        SfFormDateComponent,
        SfFormDatetimeComponent,
        SfFormTimeComponent,
        UserFormComponent,
        NavbarComponent,
        CrmNavbarComponent,
        LoginComponent,
        DashboardComponent,
        ReloadPageComponent,
        AccountsNavbarComponent,
        CartComponent,
        CartTableComponent,
        OrdersTableComponent,
        ItemTableComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        SetPasswordComponent,
        InviteComponent,
        PermitFinderComponent,
        ApplyStartComponent,
        RecreationChooserComponent,
        ApplyBusinessLoginComponent,
        PermitTypeChooserComponent,
        ApplyShellComponent,
        PermitResultComponent,
        ApplyTouristPassComponent,
        ApplyRecreationComponent,
        ApplyFriendsFamilyComponent,
        ApplyWorkComponent,
        ApplyMediaComponent,
        ApplyFishingHuntingComponent,
        ApplyResearchComponent,
        HostConfirmComponent,
        PermitStatusBadgeComponent,
        PermitCommonDetailsComponent,
        TouristPassDetailComponent,
        RecreationDetailComponent,
        FriendsFamilyDetailComponent,
        WorkDetailComponent,
        MediaDetailComponent,
        FishingHuntingDetailComponent,
        PermitPayComponent,
        ClosureNoticeComponent,
        ClosuresTableComponent,
        PagesTableComponent,
        ResearchDetailComponent,
        PermitDetailComponent,
        PermitHistoryComponent,
        ViewPermitComponent,
        EditPermitComponent,
        HomeComponent,
        PageComponent,
        MyPermitsComponent,
    ],

    imports: [
        CommonModule,
        NgxStripeModule,
        FormsModule,
        RouterModule,

        // To be exported
        Ngxh6Module,
        SfFormModule.forRoot({
            customTypes: [
                { prefix: 'date', component: SfFormDateComponent },
                { prefix: 'datetime', component: SfFormDatetimeComponent },
                { prefix: 'time', component: SfFormTimeComponent },
                { prefix: 'file_upload', component: SfFormFileuploadComponent },
            ],
        }),
        DropzoneModule,
        MomentModule.forRoot({
            relativeTimeThresholdOptions: {
                s: 60,
                m: 60,
                h: 24,
                d: 7,
                w: 4,
                M: 12,
            },
        }),
        NotificationBadgeComponent,
        NgbModule,
        ReactiveFormsModule,
    ],
    exports: [
        // Declared
        SfFormDateComponent,
        SfFormDatetimeComponent,
        SfFormTimeComponent,
        NavbarComponent,
        CrmNavbarComponent,
        PermitTypeChooserComponent,
        ApplyShellComponent,
        PermitResultComponent,
        PermitStatusBadgeComponent,
        PermitDetailComponent,
        PermitHistoryComponent,
        ClosureNoticeComponent,
        ClosuresTableComponent,
        PagesTableComponent,

        // IMPORTS:
        Ngxh6Module,
        SfFormModule,
        AccountsNavbarComponent,
    ],
    providers: [
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG,
        },
    ],
})
export class SharedModule {}
